import React from 'react';
import { BaseButton, useAuth, useIsMobile } from '@repo/common';
import InvoiceDetailHeader from './InvoiceHeader';
import InvoiceDetailTable from './InvoiceTable';
import InvoiceDetailBottom from './InvoiceBottom';

import { ReactComponent as DownloadIcon } from '@repo/common/assets/icons/16px/icon_16px_download.svg';

const Invoice = ({ data }) => {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const isAdmin = user?.role === 'A';

  const handleDownloadReceipt = () => {
    window.open(data.receiptUrl, '_blank');
  };

  if (isMobile) {
    return (
      <div className='flex flex-col gap-4 w-full'>
        <div className='rounded-[15px] bg-grayscale-gray00 p-4'>
          <InvoiceDetailHeader data={data} $isMobile={isMobile} />
          {/* 계좌이체 결제는 PG 영수증이 없다 — receiptUrl 이 있을 때만 */}
          {data?.receiptUrl && (
            <div className='mt-4'>
              <BaseButton
                type='text_basic'
                size='l'
                icon={<DownloadIcon />}
                onClick={handleDownloadReceipt}
                width='100%'
                bgclass='pl-3'
              >
                Receipt
              </BaseButton>
            </div>
          )}
          {isAdmin && (
            <div className='flex flex-col gap-2 mt-3'>
              <BaseButton type='text_basic' hideIcon>
                Payment cancel
              </BaseButton>
              <BaseButton type='text_basic' hideIcon>
                Force full refund
              </BaseButton>
            </div>
          )}
        </div>

        <div className='rounded-[15px] bg-grayscale-gray00 p-4 border border-grayscale-gray02'>
          <InvoiceDetailTable data={data} $isMobile={isMobile} />
          {!isMobile && (
            <InvoiceDetailBottom data={data} $isMobile={isMobile} />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className='flex flex-col items-start p-[30px] gap-[30px] rounded-[15px] bg-grayscale-gray00 w-full'>
      <InvoiceDetailHeader data={data} />
      <div className='flex items-start gap-4'>
        {data?.receiptUrl && (
          <BaseButton
            type='text_basic'
            icon={<DownloadIcon />}
            onClick={handleDownloadReceipt}
          >
            Download receipt
          </BaseButton>
        )}
        {isAdmin && (
          <>
            <BaseButton type='text_basic' hideIcon>
              Payment cancel
            </BaseButton>
            <BaseButton type='text_basic' hideIcon>
              Force full refund
            </BaseButton>
          </>
        )}
      </div>
      <InvoiceDetailTable data={data} />
      <InvoiceDetailBottom data={data} />
    </div>
  );
};

export default Invoice;
